module.exports = __webpack_public_path__ + "997ef7638a0709d952e1d8402c164a3b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/chili-s.png
// module id = 2504
// module chunks = 0